import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { AUDCountries, countryGroups, GBPCountries, NZDCountries, UnitedStates, } from '@modules/internationalisation/countryGroup';
import { sendTrackingEventsOnClick } from 'helpers/productPrice/subscriptions';
import { getPatronsLink } from 'helpers/urls/externalLinks';
import { routes } from 'helpers/urls/routes';
import { linksList, linksListItem, linksListItemActive, linksListItemNavigate, linksListItemTabletDisplay, linksNav, } from './linksStyles';
const links = [
    {
        href: routes.recurringContribCheckout,
        text: 'Contributions',
        trackAs: 'contributions',
        additionalStyles: linksListItemTabletDisplay,
        internal: true,
    },
    {
        href: routes.subscriptionsLanding,
        text: 'Subscriptions',
        trackAs: 'subscriptions',
        internal: true,
    },
    {
        href: routes.digitalSubscriptionLanding,
        text: 'Digital',
        trackAs: 'subscriptions:digital',
        internal: true,
    },
    {
        href: routes.paperSubscriptionLanding,
        text: 'Newspaper',
        trackAs: 'subscriptions:paper',
        include: [GBPCountries],
        internal: true,
    },
    {
        href: routes.guardianWeeklySubscriptionLanding,
        text: 'Guardian Weekly',
        trackAs: 'subscriptions:guardianweekly',
        internal: true,
    },
    {
        href: getPatronsLink('support-header'),
        text: 'Patrons',
        trackAs: 'patrons',
        opensInNewWindow: true,
        exclude: [AUDCountries, NZDCountries, UnitedStates],
        internal: false,
    },
];
function internationalisationID(countryGroupId) {
    if (countryGroupId != null) {
        const group = countryGroups[countryGroupId];
        return group.supportRegionId;
    }
    return null;
}
function isActiveLink(urlWithoutParams, href) {
    return (urlWithoutParams.endsWith(href) ||
        urlWithoutParams.endsWith(`${href}/delivery`));
}
// Export
function Links({ location, getRef, countryGroupId, cssOverride, }) {
    const { protocol, host, pathname } = window.location;
    const urlWithoutParams = `${protocol}//${host}${pathname}`;
    const internationalisationIDValue = internationalisationID(countryGroupId);
    const isNotUk = internationalisationIDValue !== 'uk';
    return (_jsx("nav", { css: [linksNav, cssOverride], children: _jsx("ul", { css: linksList, ref: getRef, children: links
                .filter(({ text }) => {
                if (text === 'Digital' ||
                    text === 'Support' ||
                    text === 'Contributions' ||
                    (text === 'Newspaper' && isNotUk) ||
                    (text === 'Subscriptions' && isNotUk)) {
                    return false;
                }
                return true;
            })
                .filter(({ include, exclude }) => {
                // If there is no country group ID for the link, return true and include the link in the rendering.
                if (!countryGroupId) {
                    return true;
                }
                // If the link is not meant to be included for a specific CountryGroupID, do not include in array.
                if (include && !include.includes(countryGroupId)) {
                    return false;
                }
                // If the link is meant to be excluded for a specific CountryGroupID, exclude from array.
                if (exclude?.includes(countryGroupId)) {
                    return false;
                }
                // Otherwise return true.
                return true;
            })
                .map((link) => {
                if (internationalisationIDValue == null || !link.internal) {
                    return link;
                }
                return {
                    ...link,
                    href: `/${internationalisationIDValue}${link.href}`,
                };
            })
                .map(({ href, text, trackAs, opensInNewWindow, additionalStyles }) => (_jsx("li", { css: [
                    linksListItem,
                    isActiveLink(urlWithoutParams, href) && linksListItemActive,
                    additionalStyles,
                ], children: _jsx("a", { onClick: sendTrackingEventsOnClick({
                        id: ['header-link', trackAs, location].join(' - '),
                        componentType: 'ACQUISITIONS_OTHER',
                    }), css: linksListItemNavigate, href: href, target: opensInNewWindow ? '_blank' : '', children: text }) }))) }) }));
}
Links.defaultProps = {
    getRef: null,
};
export default Links;
